module.exports = __webpack_public_path__ + "static/media/plan-mas-gb-libre-plus.e010c84c.svg";